module.exports = __webpack_public_path__ + "img/9.6f69ec9e.jpg";